/*
 * Fixes an issue with the TinyMCE configuration that does not allow boolean attributes on style formats
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[download=" "]').forEach((elem, ind) => {
    elem.setAttribute('download', '');
  });
});